import React from "react";
import { Reveal } from "./Reveal";
import { IMAGES } from "../../data/content";
import { useLang } from "../../i18n/LanguageContext";

export const ProblemSolution = () => {
  const { t } = useLang();
  return (
    <section className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-28">
      <div className="grid items-center gap-12 lg:grid-cols-2">
        <Reveal>
          <div className="relative">
            <img
              src={IMAGES.family}
              alt="Familie kocht gemeinsam"
              className="w-full rounded-3xl object-cover shadow-[0_20px_60px_rgba(15,37,55,0.15)]"
              style={{ aspectRatio: "4 / 3" }}
            />
            <div className="absolute -bottom-6 -right-4 max-w-[220px] rounded-2xl bg-terracotta p-5 text-white shadow-xl sm:right-6">
              <p className="font-heading text-lg font-extrabold leading-snug">
                {t.problem.overlay}
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div>
            <p className="text-sm font-bold uppercase tracking-widest text-terracotta">
              {t.problem.badge}
            </p>
            <h2 className="mt-3 font-heading text-3xl font-extrabold tracking-tight text-petrol sm:text-4xl">
              {t.problem.title}
            </h2>
            <ul className="mt-6 space-y-3">
              {t.problem.pains.map((p) => (
                <li
                  key={p}
                  className="flex items-start gap-3 rounded-2xl bg-white p-4 text-petrol-soft shadow-sm"
                >
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cream font-heading text-sm font-bold text-terracotta">
                    ?
                  </span>
                  <span className="font-semibold">{p}</span>
                </li>
              ))}
            </ul>
            <p className="mt-6 text-lg leading-relaxed text-petrol-soft">
              {t.problem.text}
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
